// extracted by mini-css-extract-plugin
export var cardHeader = "_gj-0";
export var reorderHandle = "_gj-3";
export var titleArea = "_gj-1";
export var titleAreaWithHandle = "_gj-2";